export const courseData = course => ({
  course_id: course.course_id || null,
  name: course.name,
  par: course.par ?? null,
  holes: course.holes || course.hole_pars?.length || 18,
  hole_pars: Array.isArray(course.hole_pars) ? course.hole_pars : [],
  hole_handicaps: Array.isArray(course.hole_handicaps) ? course.hole_handicaps : [],
  hole_yardages: Array.isArray(course.hole_yardages) ? course.hole_yardages : [],
  tees: Array.isArray(course.tees) ? course.tees : [],
  api_course_id: course.api_course_id ?? course.id ?? null,
  location: typeof course.location === 'string' ? course.location : '',
  latitude: course.latitude ?? null,
  longitude: course.longitude ?? null,
  course_type: course.course_type || 'standard',
  nines: Array.isArray(course.nines) ? course.nines : null,
});